module.exports = __webpack_public_path__ + "static/media/vest.ffb97422.svg";